import BaseRepository from '@/api/repositories/BaseRepository';

export default class AppsEmployeeRepository extends BaseRepository {
	postRepairPlanStep(data) {
		return this.post(`apps/employee/repairplan`, {}, data);
	}
}
